import actions from './actions';
import mutations from './mutations';
import theme from './theme/index';

const state = {
  adhocId: 432,
  awsId: 21,
  sections: {},
  // isTouchscreen: true,
  // forPublic: true,
  isTouchscreen: false,
  forPublic: true,
  showPrices: false,
  hasAvailabilty: true,
  hasScaleModel: true,
  assetsUrl: 'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/',
  sales: {
    name: 'The Residences At Queen\'s Marque',
    // email: 'hello@blacklineapp.com',
    email: 'do_not_reply@adhocstudio.ca',
    phone: ''
  }
};

export default {
  namespaced: true,
  modules: {
    theme
  },
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/project/index.js